"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ColorLookup_1 = __importDefault(require("./ColorLookup"));
function default_1(color, defaultColor) {
    var colorCode = '';
    if (color && color[0] === '#') {
        colorCode = color;
    }
    else if (color) {
        colorCode = ColorLookup_1.default(color);
    }
    else if (defaultColor) {
        colorCode = defaultColor + "55";
    }
    return colorCode;
}
exports.default = default_1;
//# sourceMappingURL=parseColor.js.map